/* eslint-disable-jsx-a11y/anchor-is-valid*/
import React from 'react'
import {Dialog, DialogActions, DialogTitle, Button, CircularProgress} from '@material-ui/core'

export default function FileSubmissionModal(props){

    const {
        handleClose,
        modalProps:{ setIsModalOpen, isModalOpen, status, modalTitle } 
    } = props

    const closeModal = () => {
        setIsModalOpen(false)
        if(handleClose){
            handleClose()
        }
    }
    
    return (
        <div>
            <Dialog
                open={isModalOpen}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{modalTitle}</DialogTitle>
                <DialogActions>
                    { status === 'uploading' &&
                    <CircularProgress />
                    }
                    { status !== 'uploading' &&
                    <Button onClick={closeModal}>
                        Close
                    </Button>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
}